import "./instruccionesSolicitudA1A2.scss";
import { memo } from "react";
import React, { useEffect } from "react";
import Titulo from "../../components/atoms/titles/Titulo";
import ButtonVolver from "../../components/atoms/buttons/ButtonVolver";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { Link } from "react-router-dom";
import { useLocalStorage } from "../../hooks/useLocalStorage";

const InstruccionesSolicitudA1A2 = () => {
  const [token] = useLocalStorage("token", "");
  useEffect(() => {}, [token]);

  function InstruccionesSolicitudA1A2() {
    return (
      <>
        <Header></Header>
        <div className="container d-flex flex-column mt-5" role="main" data-landmark-index="4">
          {/* INFORMACION */}
          <div className="container p-5 bg1Gris m-2">
            <Titulo
              titulo={"Instrucciones para la Gestión de Solicitudes"}
              tipo={"tituloPagina"}
            />
            <Titulo titulo={"Gestión de Solicitudes"} tipo={"tituloPagina"} />
            <p>
              Dependiendo de si puede rellenar las solicitudes correspondientes
              a la adquisición de la especialidad de Empleo relativa al Cuerpo
              de Titulados Superiores (A1) o al Cuerpo de Técnicos (A2) le
              aparecerá en pantalla una zona donde podrá:
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={"Crear Solicitudes"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Desde el botón <span className="fw-bold">"Solicitud"</span> de
              esta página podrá crear un borrador para esa solicitud. Dicho
              borrador puede ser grabado tantas veces como desee. Si existe un
              borrador grabado previamente el sistema lo recuperará al pulsar
              sobre el botón <span className="fw-bold">"Solicitud"</span>.
              Cuando pulse dicho botón, comenzará la cumplimentación de la
              solicitud, en modo borrador. Para más información sobre cómo
              rellenar las mismas, consulte la sección "Como cumplimentar su
              solicitud".
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={"Modificación de Solicitudes"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Una vez creado su borrador y mientras que no lo haya validado,
              puede volver a acceder a él para modificarlo tanto como desee
              desde el propio botón <span className="fw-bold">"Solicitud"</span>
              , en el que encontrará un borrador grabado previamente que el
              sistema recuperará y le llevará a la ventana de cumplimentación de
              la solicitud para realizar las modificaciones que desee.
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={"Validación de Borradores"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Los borradores que genere no serán válidos administrativamente
              hasta que no los haya validado. Para ello, desde esta ventana,
              deberá pulsar el botón{" "}
              <span className="fw-bold">"Solicitar"</span>, que marcará su
              solicitud como confirmada.
            </p>
            <div className="fondoGris">
              <p className="fw-bold m-2">
                IMPORTANTE: Una vez que haya validado un borrador NO PODRÁ
                VOLVER A MODIFICARLO. Debe asegurarse de que los datos que ha
                introducido son los correctos, antes de marcar la solicitud como
                válida. Se recomienda que se visualice el borrador, antes de
                validarlo y que se revise completamente que los datos que
                aparecen en él son los correctos. Una vez comprobado, puede
                validar la solicitud.
              </p>
            </div>
            <p>
              Si aun después de validar la solicitud quisiera modificarla, la
              única opción sería crear un nuevo borrador desde el principio, con
              la información correcta y después validarlo, con lo cual
              desaparecerá el documento validado anteriormente. Solamente debe
              existir un documento validado.
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={"Generar PDF de una Solicitud"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              <span className="text-decoration-underline text-black">
                Generar solicitudes validadas:
              </span>{" "}
              Una vez que su solicitud esté correctamente cumplimentada y
              validada, debe descargarla en formato PDF para poder firmarla
              electrónicamente y posteriormente registrarla telemáticamente de
              la manera indicada en el apartado 5 de estas instrucciones. Para
              ello deberá pulsar el botón
              <span className="fw-bold"> "Imprimir"</span> de la solicitud
              presentada (validada), utilizando la opción de impresión "Guardar
              PDF".
            </p>
            <div className="fw-bold">
              <p>RECUERDE...</p>
              <p>
                Los pasos que debe seguir para la correcta cumplimentación de
                una solicitud de participación:
              </p>
              <ol>
                <li>
                  1. Seleccionar la solicitud que corresponda (Adquisición de la
                  especialidad de Empleo en el Cuerpo de Titulados Superiores o
                  Adquisición de la especialidad de Empleo en el Cuerpo de
                  Técnicos).
                </li>
                <li>2. Crear el borrador de solicitud.</li>
                <li>3. Modificarlo según necesite.</li>
                <li>4. Validar la solicitud.</li>
                <li>5. Descargar el documento generado.</li>
                <li>
                  6. Firmarla digitalmente y presentarla en el Registro
                  Electrónico de la Junta de Extremadura o en el de la
                  Administración General del Estado (como se indica en el
                  apartado 5 de este documento), junto con el documento o carta
                  de pago generado (como se indica en el apartado 4 de estas
                  instrucciones).
                </li>
              </ol>
            </div>
            <Titulo
              titulo={"Cómo cumplimentar su solicitud"}
              tipo={"tituloPagina underlineRed"}
            />
            <p>
              Cuando pulse el botón{" "}
              <span className="fw-bold"> "Solicitud" </span> de la página de
              gestión de solicitudes, será llevado a una página inicial donde
              podrá rellenar el Anexo de la solicitud, obligatorio para la
              admisión de la misma. Dicho anexo se divide en seis apartados:
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={"Apartado 1 - Datos personales"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Incluye los datos personales de la persona solicitante. Todos los
              datos son de obligatoria cumplimentación y aparecen identificados,
              por este motivo, con un asterisco. Inicialmente se cargarán
              automáticamente los campos correspondientes al DNI, Nombre, Primer
              apellido y Segundo apellido, que aparecen registrados en el
              Sistema de Información y Gestión de Recursos Humanos de la Junta
              de Extremadura (SIRhUS). A continuación, se rellenarán los campos
              relativos a la fecha de nacimiento y de contacto, es decir,
              Domicilio, Localidad, Provincia, Código Postal, Teléfono de
              contacto y Correo electrónico de contacto.
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={"Apartado 2 - Datos profesionales"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Incluye únicamente el Cuerpo de pertenencia que le habilita para
              participar en la convocatoria de adquisición de la Especialidad de
              Empleo. Este dato aparecerá cargado automáticamente en el borrador
              de solicitud, proveniente del Sistema de Información y Gestión de
              Recursos Humanos de la Junta de Extremadura (SIRhUS).
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={
                "Apartado 3 - Solicitud de adaptación en tiempo y medios necesarios para la realización del ejercicio"
              }
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Contiene los campos de cumplimentación no obligatoria, que pueden
              ser utilizados por las personas aspirantes con discapacidad para
              solicitar las adaptaciones en tiempo y medios necesarios para la
              realización del ejercicio. Se compone del campo "Grado de
              discapacidad", en el que se indicará el tanto por ciento que tenga
              reconocida la persona discapacitada, y del campo "Adaptación que
              solicita", en el que describirá la petición concreta de adaptación
              en la que se reflejen las necesidades específicas que demanda la
              persona con discapacidad para acceder al proceso selectivo en
              condiciones de igualdad.
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={"Apartado 4 - Tasa por derecho a examen"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Incluye los datos correspondientes a la tasa por derecho de
              examen. Deberá marcar el check que corresponda con su situación.
              En el caso que se encuentre obligado al pago de la tasa por
              derecho a examen por no hallarse incluido en ninguno de los
              supuestos de exención que se indican en el siguiente párrafo
              deberá señalar el check "Abono completo de la tasa" (Con el
              importe que corresponda según se trate de la solicitud para la
              adquisición de la especialidad de Empleo en el Cuerpo de Titulados
              Superiores (38,52€) o en el de Técnico (34,66€), y que aparece
              indicado en la solicitud respectiva).
            </p>
            <p>
              En el supuesto que se halle exento del pago de la tasa deberá
              marcar el check "Exento del abono de la tasa por", indicando que
              se encuentre en alguno de los supuestos siguientes y señalando el
              check que corresponda:
            </p>
            <ol>
              <li className="my-2">
                a) Las personas aspirantes con un grado de discapacidad igual o
                superior al 33 por ciento ("Grado de discapacidad igual o
                superior al 33%")
              </li>
              <li className="my-2">
                b) Las personas aspirantes que tengan la condición de víctimas
                del terrorismo, cónyuges o parejas de hecho, así como sus hijos
                ("Víctimas del terrorismo, cónyuges, parejas de hecho, así como
                sus hijos")
              </li>
              <li className="my-2">
                c) Las personas que tengan la consideración de víctimas de
                violencia de género a que hace referencia la Ley Orgánica
                1/2004, de 28 de diciembre, de Medidas de Protección Integral
                contra la Violencia de Género ("Víctimas de violencia de
                género")
              </li>
            </ol>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={
                "Apartado 5 - Declaración y espacio para la firma electrónica de la solicitud"
              }
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Este apartado, sin campos que cumplimentar, está destinado para
              recoger la declaración de la persona participante en el proceso de
              que son veraces los datos personales contenidos en la misma y que
              acepta y otorga su consentimiento expreso para que estos sean
              tratados con la única finalidad de que sean utilizados para
              gestionar su participación en el procedimiento de adquisición de
              la especialidad de Empleo. Incluye, asimismo, un espacio para que
              se firme electrónicamente la solicitud.
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold underlineRed"}
              tipo={"tituloCard noBg"}
              titulo={"Apartado 6 - Cláusula de protección de datos"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              Apartado meramente informativo sobre la política de protección de
              datos aplicado al procedimiento (responsable del tratamiento,
              finalidad del tratamiento, legitimación del tratamiento y derechos
              de las personas interesadas). Contiene un enlace al anexo con
              información adicional sobre el mismo.
            </p>
            <Titulo
              titulo={"Abono de la tasa por derecho a examen"}
              tipo={"tituloPagina underlineRed"}
            />
            <p>
              El ingreso de la tasa por derecho de examen, si procede al no
              encontrarse en ninguno de los supuestos de exención definidos en
              el punto tercero de estas instrucciones, se efectuará
              telemáticamente a través de la página web
              <Link
                to={""}
                onClick={() => {
                  window.open("https://modelo050.juntaex.es/modelo050/");
                }}
              >
                {" "}
                https://modelo050.juntaex.es/modelo050/
              </Link>
              , siendo el código de la tasa por derechos de examen el 100161,
              debiendo acompañarse a la solicitud, cuando se registre
              electrónicamente, el documento justificativo del ingreso.
            </p>
            <p>
              Como ayuda a la cumplimentación de este trámite se indican unas
              pequeñas pautas orientativas a seguir en la realización de este
              trámite telemático que exponemos a continuación:
            </p>
            <ol type="1">
              <li className="my-2">
                a) En primer lugar, en la ventana la "seleccione tasa o el
                precio público" elegiremos la opción "Otros".
              </li>
              <li className="my-2">
                b) Cumplimentaremos exclusivamente los campos sombreados en rosa
                (aparecen identificados con un *) de la siguiente forma: Órgano
                gestor:{" "}
                <span className="tw-bold">
                  {" "}
                  10.- HACIENDA Y ADMINISTRACIÓN PÚBLICA
                </span>
                , Concepto:{" "}
                <span className="tw-bold">
                  {" "}
                  100161 - Por Derechos de Exámenes,{" "}
                </span>{" "}
                NIF, apellidos y nombre, bloque de campos de dirección y
                contacto (Tipo de vía, Nombre de vía pública, Tipo de número,
                numero, Provincia, Número, Código Postal y Correo Electrónico),
                y TOTAL A INGRESAR: <span className="tw-bold">
                  38,52 euros
                </span>{" "}
                para la solicitud de adquisición de la especialidad de Empleo en
                el Cuerpo de Titulados Superiores y{" "}
                <span className="tw-bold"> 34,66 euros </span> para la solicitud
                de adquisición de la especialidad de Empleo en el Cuerpo de
                Técnicos.
              </li>
              <li className="my-2">
                c) Por último, se pulsará el botón "Validar Modelo050" para
                proceder a la generación del modelo 50 y ser redirigido al TPV
                de la entidad bancaria que presta el servicio a la Comunidad
                Autónoma. Efectuado el pago{" "}
                <span className="tw-bold">
                  {" "}
                  no olvide imprimir/guardar el modelo 050{" "}
                </span>{" "}
                para su posterior presentación junto a la solicitud de
                participación para su posterior presentación junto a la
                solicitud de participación en el procedimiento de adquisición de
                la especialidad de Empleo por los funcionarios de carrera de los
                Cuerpos Titulados Superiores y/o Técnicos de la forma indicada
                en el apartado 5 de estas instrucciones. Si lo desea puede
                recibir el modelo pagado en una dirección de email.
              </li>
            </ol>
            <p>
              En ningún caso el pago telemático de la tasa supondrá la
              sustitución del trámite de presentación, en tiempo y en forma, de
              la solicitud conforme a lo dispuesto en el apartado posterior.
            </p>
            <Titulo
              titulo={
                "Registro electrónico de la solicitud generada en el Portal del Empleado Público"
              }
              tipo={"tituloPagina underlineRed"}
            />
            <p>
              El registro telemático de la solicitud y de los documentos que
              acompañe (justificante del pago de la tasa por derecho de examen)
              se podrá realizar mediante el Registro Electrónico General de la
              Junta de Extremadura a través de la dirección:
            </p>
            <p>
              <Link
                to={""}
                onClick={() => {
                  window.open(
                    "https://sede.gobex.es/SEDE/registroGeneral/registroGeneral.jsf"
                  );
                }}
              >
                https://sede.gobex.es/SEDE/registroGeneral/registroGeneral.jsf
              </Link>
              , marcando el botón Registro electrónico y accediendo por la
              opción DNIe/Certificado electrónico.
            </p>
            <p>
              En primer lugar, cumplimentará los datos del solicitante, datos
              del domicilio y de contacto del solicitante (en el caso de que no
              se encuentren actualizado o figuren erróneos si desea modificarlos
              podrá dirigirse al servicio de soporte en la dirección de correo
              electrónico: soporte.sedejuntaex.es o a través del teléfono:
              924336975 (Teléfono en horario, de Lunes a viernes, de 09:00 a
              14:00 horas).{" "}
              <span className="fw-bold text-black">
                {" "}
                Indicar que el domicilio que se tendrá en cuenta a efectos de
                notificaciones es el expresado en el modelo de solicitud
                cumplimentado y generado a través de la zona privada del Portal
                del Empleado Público, no teniéndose en cuenta para estos efectos
                el que aparezca registrado en la Sede Electrónica.
              </span>
            </p>
            <p>
              En segundo lugar, rellenará los datos de la solicitud. Para
              facilitar la cumplimentación de este formulario le indicamos las
              siguientes pautas:
            </p>
            <ol>
              <li className="my-2">
                a) En el campo UNIDAD DE DESTINO seleccionará el código DIR
                A11019085 correspondiente al Servicio de Gestión y Provisión de
                Personal dependiente de la Dirección General de Función Pública
                de la Vicepresidencia Primera y Consejería de Hacienda y
                Administración Pública.
              </li>
              <li className="my-2">
                b) En el campo <span className="fw-bold"> RESUMEN </span> puede
                transcribir el siguiente texto: "SOLICITUD DE PARTICIPACIÓN PARA
                LA ADQUISICIÓN DE LA ESPECIALIDAD DE EMPLEO POR LOS FUNCIONARIOS
                DE CARRERA PERTENECIENTES AL CUERPO DE TITULADOS SUPERIORES (o
                TÉCNICOS, según proceda) DE LA ADMINISTRACIÓN DE LA COMUNIDAD
                AUTÓNOMA DE EXTREMADURA."
              </li>
              <li className="my-2">
                c) En el campo <span className="fw-bold"> EXPONE </span> puede
                transcribir el siguiente texto: "QUE REUNIENDO LOS REQUISITOS Y
                CONDICIONES PARA PARTICIPAR EN EL PROCEDIMIENTO INDICADO EN EL
                CAMPO ANTERIOR Y ADJUNTANDO EL MODELO DE SOLICITUD NORMALIZADO
                GENERADO A TRAVES DEL PORTAL DEL 6 EMPLEADO PÚBLICO JUNTO AL
                JUSTIFICANTE DEL PAGO DE LA TASA" (Sólo en este último caso si
                no estuviera exento al pago de la misma).
              </li>
              <li className="my-2">
                d) En el campo SOLICITA puede transcribir el siguiente texto:
                "SE TENGA POR ADMITIDA MI SOLICITUD PARA PARTICIPAR EN EL
                PROCEDIMIENTO INDICADO EN CAMPO RESUMEN PRECEDENTE". A
                continuación, pulsará el botón "Continuar".
              </li>
            </ol>
            <p>
              En tercer lugar, visualizará la cláusula de protección de datos y
              su ficha de información adicional. En este caso no tendrá que
              cumplimentar ningún campo, procediendo a pulsar el botón
              "Continuar".
            </p>
            <p>
              En cuarto lugar, adjuntará la solicitud de participación en el
              procedimiento generada en la parte privada del Portal del Empleado
              Público y firmada de forma electrónica (formato PDF), así como el
              documento o carta que justifique el pago de las tasas de examen
              (formato PDF), en este último caso, si no se encuentra en ninguno
              de los supuestos de exclusión. Para ello utilizará el campo
              "Aportar documento", tantas veces como lo necesite, eligiendo la
              opción "Documento existente". Finalmente pulsará el botón "Pulsar"
            </p>
            <p>
              Por último, debe firmar electrónicamente su solicitud telemática y
              registrarla simultáneamente a través del botón "Firmar y
              registrar". De la misma forma, se podrá realizar a través del
              Registro Electrónico General de la Administración General del
              Estado mediante la siguiente dirección:
              <Link
                to={""}
                onClick={() => {
                  window.open(
                    "https://sede.administracion.gob.es/PAG_Sede/ServiciosElectronicos/RegistroElectronicoGeneral.html"
                  );
                }}
              >
                https://sede.administracion.gob.es/PAG_Sede/ServiciosElectronicos/RegistroElectronicoGeneral.html
              </Link>
            </p>
            <p>
              Para la utilización de cualquiera de los registros referidos, las
              personas solicitantes habrán de disponer de DNI electrónico o
              certificado digital.
            </p>

            <p>
              Si no disponen de ellos podrán obtenerlos a través de las
              siguientes direcciones electrónicas:
            </p>
            <ol>
              <li className="my-2">
                <Link
                  to={""}
                  onClick={() => {
                    window.open(
                      "https://www.dnielectronico.es/PortalDNIe/PRF1_Cons02.action?pag=RF_009"
                    );
                  }}
                >
                  https://www.dnielectronico.es/PortalDNIe/PRF1_Cons02.action?pag=RF_009
                </Link>
              </li>
              <li className="my-2">
                <Link
                  to={""}
                  onClick={() => {
                    window.open("http://www.cert.fnmt.es/");
                  }}
                >
                  http://www.cert.fnmt.es/
                </Link>
              </li>
            </ol>
            <div className="direccion d-flex flex-column align-items-center mt-5 text-center">
              <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
              <p className="text-center">
                Avda. Valhondo s/n, Edificio III Milenio, Módulo 1- 1ª planta.
                06800 - MÉRIDA
              </p>
            </div>
            <div className="d-flex mb-3">
              <ButtonVolver clases={""} destino={"adquisicion"}></ButtonVolver>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </>
    );
  }

  return <>{InstruccionesSolicitudA1A2()}</>;
};

export default memo(InstruccionesSolicitudA1A2);
